<template>
  <span v-if="is_known" class="availability-toggle">
    <vb-checkbox
      @change="(value) => $emit('toggle', value)"
      :vb_options="{
        switch: true,
        text: 'Mostra in base al credito',
        value: active,
      }"
    />
  </span>
</template>

<script>
export default {
  name: "availability-toggle",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    is_known: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.availability-toggle {
  display: block;
  margin-top: $grid-gutter-width;

  @include media-breakpoint-up(sm) {
    display: inline;
    margin-top: 0;
  }
}
</style>
